jQuery(document).ready( function() {

//RECHERCHE HEADER --------------
	jQuery( ".site-header-search" ).click(function() {
    jQuery("#head_search").toggleClass( 'head_search_show' );
	});


//MENU MOBILE --------------
	jQuery("#mobil_menu_btn").click(function() {
		jQuery("body").toggleClass("body-lock");
		jQuery(".site-header").toggleClass('nav-open');
		jQuery("#site-navigation-mobile-eveno").toggleClass('open');
		jQuery("#site-navigation").toggleClass('open');
		jQuery(".mobil_menu_overlay").toggleClass('open');
	});

	jQuery(".mobil_menu_close").click(function() {
		jQuery("#site-navigation-mobile-eveno").toggleClass('open');
		jQuery("#site-navigation").toggleClass('open');
		jQuery(".mobil_menu_overlay").toggleClass('open');
		if(jQuery("body").hasClass("body-lock")) {
			jQuery("body").removeClass("body-lock")
		}
		if(jQuery(".site-header").hasClass("nav-open")) {
			jQuery(".site-header").removeClass("nav-open")
		}

	});

	jQuery(".dropdown-toggle").click(function() {
		if(jQuery(this).hasClass("toggled-on")) {
			jQuery(this).next(".sub-menu").slideDown();
		} else {
			jQuery(this).next(".sub-menu").slideUp();
		}
	});



//IMAGE INTERACTIVE ACCUEIL --------------
	var $toutesLesInfobullesProjet = jQuery('.front_projet_infobulle');
	$toutesLesInfobullesProjet.each(function() {
		var $buttonProjet = jQuery('.front_projet_infobulle_btn', this);
		var $infoProjet = jQuery(this).next('.front_projet_infobulle_info');
		$buttonProjet.click((function () {
			var $toutesInfobullesSaufCouranteProjet = $toutesLesInfobullesProjet.not(this)
			$toutesInfobullesSaufCouranteProjet.find('.front_projet_infobulle_btn').removeClass('infobulle_activ');
			$toutesInfobullesSaufCouranteProjet.next('.front_projet_infobulle_info').removeClass('infobulle_activ');
			$buttonProjet.toggleClass('infobulle_activ');
			$infoProjet.toggleClass('infobulle_activ');
		}).bind(this));
	});


//IMAGE INTERACTIVE MAISON CONNECTEE --------------
	var $toutesLesInfobulles = jQuery('.MaisonConnectee_infobulle');
	$toutesLesInfobulles.each(function() {
		var $button = jQuery('.MaisonConnectee_infobulle_btn', this);
		var $info = jQuery(this).next('.MaisonConnecteeInfobulle');
		$button.click((function () {
			var $toutesInfobullesSaufCourante = $toutesLesInfobulles.not(this)
			$toutesInfobullesSaufCourante.find('.MaisonConnectee_infobulle_btn').removeClass('infobulle_activ');
			$toutesInfobullesSaufCourante.next('.MaisonConnecteeInfobulle').removeClass('infobulle_activ');
			$button.toggleClass('infobulle_activ');
			$info.toggleClass('infobulle_activ');
		}).bind(this));
	});


//ACCORDEON ACF --------------
	jQuery('.toggle').click(function(e) {
  	e.preventDefault();
  
    var $this = jQuery(this);

    if ($this.next().hasClass('show')) {
    	$this.parent().removeClass('accordion-active');
        $this.next().removeClass('show');
        $this.next().slideUp(350);
    } else {
        $this.parent().parent().find('li .inner').removeClass('show');
        $this.parent().parent().find('li').removeClass('accordion-active');
        $this.parent().parent().find('li .inner').slideUp(350);
        $this.next().toggleClass('show');
        $this.parent().toggleClass('accordion-active');
        $this.next().slideToggle(350);
    }

});

//ACCORDEON ACF --------------
	jQuery('.MaisonConnecteeInfobulle_btnAccordion').click(function(e) {
  	e.preventDefault();
  
    var $this = jQuery(this);
	var $maisonContent = $this.parent().siblings(".MaisonConnecteeInfobulle_txt");
	$this.parent().toggleClass('open');
	$maisonContent.toggleClass('show');
	$maisonContent.slideToggle(350);

});


//BTN SCROLL TOP --------------

var btn = jQuery('#button-to-top');

  jQuery(window).scroll(function() {
    if (jQuery(window).scrollTop() > 300) {
      btn.addClass('show');
    } else {
      btn.removeClass('show');
    }
  });

  btn.on('click', function(e) {
    e.preventDefault();
    jQuery('html, body').animate({scrollTop:0}, '300');
  });

  jQuery('.entry-slider').slick({
	autoplay: true
  });

  jQuery('.sliderHome').slick({
	autoplay: false
  });



  


});





//////////////////
// WEBPACK FOOTER
// ./src/js/function-eveno.js
// module id = 2
// module chunks = 0